var exports = {
  "d": "x804f0401--0b8de4--star",
  "h": "x804f0401--0b8de4--input",
};

module.exports = exports;
